import React from "react";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Typography,
} from "@mui/material";

const LoginCard = ({ appName, loginURL, avatar = null }) => {
    return (
        <Card className="card">
            <CardHeader
                disableTypography
                avatar={avatar}
                title={
                    <Typography component="h3" className="card-header-title">
                        Access your account
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {appName}
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    If you already have a {appName} account, you can access it
                    here.
                </Box>
            </CardContent>
            <CardActions>
                <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    target="_blank"
                    component="a"
                    href={loginURL}
                >
                    Open
                </Button>
            </CardActions>
        </Card>
    );
};

export default LoginCard;
